<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="我的收藏">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>

             <favorite-goods></favorite-goods>
    </div>
</template>
<script>
import FavoriteGoods from './FavoriteGoods'
export default {
  components: {
    FavoriteGoods,
  },
  name: 'MemberFavorite',
  data () {
    return {
      selected: '1'
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
</style>
